import { render, staticRenderFns } from "./waitPay.vue?vue&type=template&id=139ce60a&scoped=true&"
import script from "./waitPay.vue?vue&type=script&lang=js&"
export * from "./waitPay.vue?vue&type=script&lang=js&"
import style0 from "./waitPay.vue?vue&type=style&index=0&id=139ce60a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139ce60a",
  null
  
)

export default component.exports